/**
 * @generated SignedSource<<7c217497906b19f656b2022bbdf36f0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type vaultToggleMutationsClearFeatureOverrideMutation$variables = {
  key: FeatureKey;
  vaultId: any;
};
export type vaultToggleMutationsClearFeatureOverrideMutation$data = {
  readonly clearFeatureOverride: boolean;
};
export type vaultToggleMutationsClearFeatureOverrideMutation = {
  response: vaultToggleMutationsClearFeatureOverrideMutation$data;
  variables: vaultToggleMutationsClearFeatureOverrideMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vaultId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      },
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "kind": "ScalarField",
    "name": "clearFeatureOverride",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "vaultToggleMutationsClearFeatureOverrideMutation",
    "selections": (v1/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "vaultToggleMutationsClearFeatureOverrideMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ac24f7cbf65f6ca63ce19a064e4e8ab9",
    "id": null,
    "metadata": {},
    "name": "vaultToggleMutationsClearFeatureOverrideMutation",
    "operationKind": "mutation",
    "text": "mutation vaultToggleMutationsClearFeatureOverrideMutation(\n  $key: FeatureKey!\n  $vaultId: UUID!\n) {\n  clearFeatureOverride(key: $key, vaultId: $vaultId)\n}\n"
  }
};
})();

(node as any).hash = "4f3cbc7089f39409d806b27998d73d2a";

export default node;
